import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ShowBothIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M8.56299 14.812H7.56299C7.21781 14.812 6.93799 15.0918 6.93799 15.437V16.437C6.93799 16.7822 7.21781 17.062 7.56299 17.062H8.56299C8.90817 17.062 9.18799 16.7822 9.18799 16.437V15.437C9.18799 15.0918 8.90817 14.812 8.56299 14.812Z"
        fill={color}
      />
      <path
        d="M12.5 10.875H11.5C11.1548 10.875 10.875 11.1548 10.875 11.5V12.5C10.875 12.8452 11.1548 13.125 11.5 13.125H12.5C12.8452 13.125 13.125 12.8452 13.125 12.5V11.5C13.125 11.1548 12.8452 10.875 12.5 10.875Z"
        fill={color}
      />
      <path
        d="M16.437 6.93799H15.437C15.0918 6.93799 14.812 7.21781 14.812 7.56299V8.56299C14.812 8.90817 15.0918 9.18799 15.437 9.18799H16.437C16.7822 9.18799 17.062 8.90817 17.062 8.56299V7.56299C17.062 7.21781 16.7822 6.93799 16.437 6.93799Z"
        fill={color}
      />
      <path
        d="M21.8989 2.10057C18.3306 -1.46783 11.1865 0.0858679 5.63568 5.63617C0.0853801 11.187 -1.46832 18.3311 2.10008 21.8994C5.66848 25.4677 12.8125 23.914 18.3633 18.3638C23.9136 12.813 25.4673 5.66897 21.8989 2.10057ZM16.9492 16.9497C12.3496 21.5493 6.19678 23.1685 3.51408 20.4853C0.83098 17.8027 2.45008 11.6499 7.04968 7.05017C11.6493 2.45047 17.8022 0.831468 20.4849 3.51457C23.168 6.19717 21.5488 12.35 16.9492 16.9497Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ShowBothIcon.displayName = 'ShowBothIcon';
